module.exports = __webpack_public_path__ + "img/ctrl-ecp-dagger-stub-+i.da3a346e.svg";